import type { ConstructionTimelinePhase } from "../types";
import { sortConstructionPhases } from "./constructionTimeline";

/** Dedupe, drop unknown ids, order by timeline master sequence. */
export function normalizeLinkedTimelinePhaseIds(
  phases: ConstructionTimelinePhase[],
  requested: string[] | undefined | null,
): string[] {
  if (!requested?.length) return [];
  const valid = new Set(phases.map((p) => p.id));
  const kept = [...new Set(requested.filter((id) => valid.has(id)))];
  const sorted = sortConstructionPhases(phases.filter((p) => kept.includes(p.id)));
  return sorted.map((p) => p.id);
}
